import React from 'react';

function SVGFactory({ width = 24, height = 24, Icon }) {
  return <Icon className='iconimg' width={width} height={height} />;
}

export default React.memo(SVGFactory);
